import React from 'react';

function LoadingExport() {
  return (
    <div className="lds-ellipsis">
      <div />
      <div />
      <div />
      <div />
    </div>
  );
}
export default LoadingExport;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/ExportRestaurant/components/LoadingExport.jsx